import { getText } from "../../__utils__/textUtils";

export const feedbackTexts = {
  clearAndFast: getText("CLEAR_AND_FAST_RESPONSE"),
  misunderstood: getText("MISUNDERSTOOD_MY_QUESTION"),
  understood: getText("UNDERSTOOD_MY_QUESTION"),
  slowResponse: getText("SLOW_RESPONSE"),
  helpfulCitations: getText("HELPFUL_CITATIONS"),
  handlesFollowUps: getText("HANDLES_FOLLOW_UPS_WELL"),
  poorFollowUp: getText("POOR_FOLLOW_UP_RESPONSE"),
  wrongCitations: getText("WRONG_IRRELEVANT_CITATIONS"),
  ignoredLocation: getText("RESPONSE_IGNORED_MY_LOCATION"),
  additionalFeedback: getText("ADDITIONAL_FEEDBACK"),
};

export const feedbackTagPairs = [
  {
    like: feedbackTexts.clearAndFast,
    dislike: feedbackTexts.misunderstood,
  },
  { like: feedbackTexts.understood, dislike: feedbackTexts.slowResponse },
  {
    like: feedbackTexts.helpfulCitations,
    dislike: feedbackTexts.poorFollowUp,
  },
  {
    like: feedbackTexts.handlesFollowUps,
    dislike: feedbackTexts.wrongCitations,
  },
];
